import React from 'react';
import { Link } from 'react-router-dom'; // ✅ Use Link from react-router-dom
import './BlogPostCard.css';

function BlogPostCard({ title, excerpt, image, author, date, link }) {
  return (
    <div className="blog-card">
      <img src={image} alt={`Thumbnail for ${title}`} className="blog-card-image" />
      <div className="blog-card-content">
        <h3 className="blog-card-title">{title}</h3>
        <p className="blog-card-excerpt">{excerpt}</p>
        <p className="blog-card-meta">By {author} on {date}</p>
        <Link to={link} className="blog-card-link">Read More →</Link> {/* ✅ Replaces <a href> */}
      </div>
    </div>
  );
}

export default BlogPostCard;
